import logo200Image from '../assets/img/logo/20200723_UnitySuiteSqLogo512.webp';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Form, FormGroup, Input, Label, Row, Col, InputGroup, InputGroupText } from 'reactstrap';
import Typography from '../components/Typography';
import StorageService from '../services/StorageService';
import axios from 'axios';
import {
  MdOutlineKey,
  MdEmail
} from 'react-icons/md'

class AuthForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      firstname: '',
      lastname: '',
      businessTitle: '',
      mobileCode: '',
      mobileNumber: '',
    };
  }

  get isLogin() {
    return this.props.authState === STATE_LOGIN;
  }

  get isSignup() {
    return this.props.authState === STATE_SIGNUP;
  }

  changeAuthState = authState => event => {
    event.preventDefault();

    this.props.onChangeAuthState(authState);
  };

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleSubmit = event => {
    event.preventDefault();

    const data = {
      app_key: process.env.REACT_APP_KEY,
      email: this.state.email,
    };

    const self = this;
    const url = process.env.REACT_APP_API_URL;

    if (this.props.authState == 'LOGIN') {
      data.password = this.state.password;
      axios
        .post(url + ':3000/v1/user/login', data)
        .then(response => {
          const result = response.data;
          if (result.error == true && result.message != 'Success') {
            alert(result.message);
            return;
          }
          StorageService.setSession('user_info', result.data);

          this.getOrganisationList();
        })
        .catch(error => {
          alert('Invalid email or password.');
        });
    }
  };

  getOrganisationList = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const selected_org = StorageService.getSession('selected_org');

    const data = {
      session_key: user.session_key,
    };

    axios
      .post(url + ':3000/v1/company/getUserCompany', data)
      .then(response => {
        const result = response.data;

        if (result.error == 'true' && result.message != 'Success') {
          alert(result.message);
          return;
        }

        this.setState({ organisationList: result.data });

        if (result.data.length > 0 && selected_org == null) {
          StorageService.setSession('selected_org', result.data[0]);
          this.setState({
            company: result.data[0].CompanyName,
            companyLogo: '',
          });
        }

        let defaultFt = result.data[0].Features[0].RowOrder;
        StorageService.setSession('activeApp', defaultFt - 1);

        this.props.history.push('/');
      })
      .catch(error => {
        alert(error);
      });
  };

  renderButtonText() {
    const { buttonText } = this.props;

    if (!buttonText && this.isLogin) {
      return 'Login';
    }

    if (!buttonText && this.isSignup) {
      return 'Signup';
    }

    return buttonText;
  }

  render() {
    const {
      showLogo,
      usernameLabel,
      usernameInputProps,
      passwordLabel,
      passwordInputProps,
      children,
      onLogoClick,
    } = this.props;

    return (
      <Form onSubmit={this.handleSubmit} className="AuthForm">
        <div className="text-left pb-4">
          {/* <img
            src={logo200Image}
            className="mb-3 d-block d-lg-none"
            style={{ width: 40, height: 40, cursor: 'pointer' }}
            alt="logo"
            onClick={onLogoClick}
          /> */}
          {this.isSignup ? (
            <Typography className="mb-5 h3">Sign Up for an Account</Typography>
          ) : (
            <div>
              <Typography className="h4">Sign In</Typography>
              <Typography className="h3">Unity Suite</Typography>
            </div>
          )}
        </div>
        <FormGroup>
          <Label for={usernameLabel}>{usernameLabel}</Label>
          <InputGroup >
            <InputGroupText style={{borderRadius:'25px 0 0 25px'}}>
              <MdEmail/>
            </InputGroupText>
            <Input
              style={{borderRadius:'0 25px 25px 0'}}
              {...usernameInputProps}
              value={this.state.email}
              onChange={this.changeHandler}
              required
            />
          </InputGroup>
        </FormGroup>
        {!this.isSignup && (
          <FormGroup>
            <Label for={passwordLabel}>{passwordLabel}</Label>
            <InputGroup>
              <InputGroupText style={{borderRadius:'25px 0 0 25px'}}>
                <MdOutlineKey/>
              </InputGroupText>
              <Input
                style={{borderRadius:'0 25px 25px 0'}}
                {...passwordInputProps}
                value={this.state.password}
                onChange={this.changeHandler}
                required
              />
            </InputGroup>
          </FormGroup>
        )}
        <hr />
        <Button
          style={{borderRadius:'25px'}}
          size="lg"
          color="link"
          className="theme-button-primary border-0"
          block
          type="submit"
        >
          {this.renderButtonText()}
        </Button>

        {/* <div className="text-center pt-1">
          <h6>or</h6>
          <h6>
            {this.isSignup ? (
              <a href="#login" onClick={this.changeAuthState(STATE_LOGIN)}>
                Login
              </a>
            ) : (
              <a href="#signup" onClick={this.changeAuthState(STATE_SIGNUP)}>
                Signup
              </a>
            )}
          </h6>
        </div> */}

        {children}
      </Form>
    );
  }
}

export const STATE_LOGIN = 'LOGIN';
export const STATE_SIGNUP = 'SIGNUP';

AuthForm.propTypes = {
  authState: PropTypes.oneOf([STATE_LOGIN, STATE_SIGNUP]).isRequired,
  showLogo: PropTypes.bool,
  usernameLabel: PropTypes.string,
  usernameInputProps: PropTypes.object,
  passwordLabel: PropTypes.string,
  passwordInputProps: PropTypes.object,
  firstnameLabel: PropTypes.string,
  firstnameInputProps: PropTypes.object,
  lastnameLabel: PropTypes.string,
  lastnameInputProps: PropTypes.object,
  businessTitleLabel: PropTypes.string,
  businessTitleInputProps: PropTypes.object,
  mobileCodeLabel: PropTypes.string,
  mobileCodeInputProps: PropTypes.object,
  mobileNumberLabel: PropTypes.string,
  mobileNumberInputProps: PropTypes.object,
  onLogoClick: PropTypes.func,
};

AuthForm.defaultProps = {
  authState: 'LOGIN',
  showLogo: true,
  usernameLabel: 'Email',
  usernameInputProps: {
    type: 'email',
    placeholder: 'your@email.com',
    name: 'email',
  },
  passwordLabel: 'Password',
  passwordInputProps: {
    type: 'password',
    placeholder: 'your password',
    name: 'password',
  },
  firstnameLabel: 'Firstname',
  firstnameInputProps: {
    type: 'text',
    placeholder: 'Firstname',
    name: 'firstname',
  },
  lastnameLabel: 'Lastname',
  lastnameInputProps: {
    type: 'text',
    placeholder: 'Lastname',
    name: 'lastname',
  },
  businessTitleLabel: 'Business Title',
  businessTitleInputProps: {
    type: 'text',
    placeholder: 'Business Title',
    name: 'businessTitle',
  },
  mobileCodeLabel: 'Mobile Code',
  mobileCodeInputProps: {
    type: 'text',
    placeholder: 'Mobile Code',
    name: 'mobileCode',
  },
  mobileNumberLabel: 'Mobile Number',
  mobileNumberInputProps: {
    type: 'text',
    placeholder: 'Mobile Number',
    name: 'mobileNumber',
  },
  onLogoClick: () => {},
};

export default AuthForm;
